module.exports = __webpack_public_path__ + "static/media/i-want-to-go-to-school_onetime.4c6063c3.gif";